// Auto-generated from octomil-contracts. Do not edit.

export enum Scope {
  CatalogRead = "catalog:read",
  ModelsRead = "models:read",
  ModelsWrite = "models:write",
  DevicesRegister = "devices:register",
  DevicesHeartbeat = "devices:heartbeat",
  ControlRefresh = "control:refresh",
  TelemetryWrite = "telemetry:write",
  RolloutsRead = "rollouts:read",
  RolloutsWrite = "rollouts:write",
  BenchmarksWrite = "benchmarks:write",
  EvalsWrite = "evals:write",
  CloudInference = "cloud:inference",
  CloudCredentials = "cloud:credentials",
}
